export default __webpack_public_path__ + "static/RASCI-1fc1e3490a4a1276d3dfba6b8c6e75bc.png";